/**
 * Check if a string can be safely parsed using functions like parseFloat() and parseInt()
 * @param value
 * @param options
 */
export var isValidNumberString = function (value, options) {
    var dotRegEx = new RegExp(/\./);
    var negRegEx = new RegExp(/-/);
    var misplacedNegRegEx = new RegExp(/(?!^)-/);
    var nonNumericRegEx = new RegExp(/[^0-9\.-]/);
    if (value === '' ||
        value === '.' ||
        value === '-' ||
        nonNumericRegEx.test(value)) {
        return false;
    }
    if ((options === null || options === void 0 ? void 0 : options.preventFloat) && dotRegEx.test(value))
        return false;
    if ((options === null || options === void 0 ? void 0 : options.preventNegative) && negRegEx.test(value))
        return false;
    if (value.indexOf('.') !== value.lastIndexOf('.') ||
        misplacedNegRegEx.test(value)) {
        return false;
    }
    return true;
};
//# sourceMappingURL=isValidNumberString.js.map